import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'types';
import { initialState } from './PassportPreCheckPreferences.redux';

const selectDomain = (state: RootState) => state?.passportPreCheckPreferences || initialState;

export const selectPassportPreferences = createSelector([selectDomain], passportPreferences => ({
  passportPreferencesData: passportPreferences.data,
}));
